document.addEventListener('DOMContentLoaded', () => {
    // Smooth scroll for navbar links
    document.querySelectorAll('#navbar a[href^="#"]').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        document.removeEventListener('scroll', onScroll);
  
        document.querySelectorAll('#navbar a').forEach(el => el.classList.remove('active'));
        this.classList.add('active');
  
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          window.scrollTo({
            top: target.offsetTop + 2,
            behavior: 'smooth'
          });
  
          // Atualiza hash após o scroll
          setTimeout(() => {
            history.pushState(null, null, this.getAttribute('href'));
            document.addEventListener('scroll', onScroll);
          }, 500);
        }
  
        // Se estiver usando Bootstrap collapse
        const navbar = document.getElementById('navbar');
        if (navbar.classList.contains('show')) {
          navbar.classList.remove('show');
        }
      });
    });
  
    // Scroll para o topo ao clicar no logo
    document.querySelectorAll('.logo-home, .link-home').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        document.removeEventListener('scroll', onScroll);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    });
  
    // Scroll para contato ao clicar no slider
    const sliderLinks = document.querySelectorAll('#slider a');
    sliderLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        document.removeEventListener('scroll', onScroll);
        const target = document.getElementById('contato');
        if (target) {
          window.scrollTo({
            top: target.offsetTop - 100,
            behavior: 'smooth'
          });
        }
      });
    });
  
    onScroll();
  });
  
  window.addEventListener('scroll', onScroll);
  
  function onScroll() {
    const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
    const logo = document.querySelector('#logo img');
  
    if (scrollPos > 2) {
      document.body.classList.add('small-menu');
      if (logo) {
        logo.setAttribute('width', '90');
        logo.setAttribute('height', '90');
      }
    } else {
      document.body.classList.remove('small-menu');
      if (logo) {
        logo.setAttribute('width', '123');
        logo.setAttribute('height', '137');
      }
    }
  
    // Descomente se quiser ativar o destaque de link da seção atual

    document.querySelectorAll('#nav-fhp a[href^="#"]').forEach(link => {
      const refElement = document.querySelector(link.getAttribute('href'));
      if (refElement) {
        const offsetTop = refElement.offsetTop;
        const offsetBottom = offsetTop + refElement.offsetHeight;
  
        if (scrollPos >= offsetTop && scrollPos < offsetBottom) {
          document.querySelectorAll('#nav-fhp ul li a').forEach(a => a.classList.remove('active'));
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
   
  }


